/**
 * Per-tab auth storage.
 * sessionStorage keeps each browser tab's login independent (survives refresh,
 * does not leak into other tabs). localStorage is only used once for migration
 * from older builds that stored auth globally.
 */
const AUTH_KEYS = [
  "roomround_access_token",
  "user_id",
  "organizationId",
  "showOnboarding",
  "onboardingStep",
];

export function getAuthItem(key) {
  return sessionStorage.getItem(key);
}

export function setAuthItem(key, value) {
  if (value === undefined || value === null) {
    sessionStorage.removeItem(key);
  } else {
    sessionStorage.setItem(key, String(value));
  }
  // Prevent other tabs from reading a shared / stale auth value
  localStorage.removeItem(key);
}

export function removeAuthItem(key) {
  sessionStorage.removeItem(key);
  localStorage.removeItem(key);
}

export function clearAuthStorage() {
  AUTH_KEYS.forEach((key) => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  });
}

/** One-time: move legacy localStorage auth into this tab's sessionStorage. */
export function migrateAuthFromLocalStorage() {
  let migrated = false;
  AUTH_KEYS.forEach((key) => {
    if (sessionStorage.getItem(key) != null) return;
    const legacy = localStorage.getItem(key);
    if (legacy != null) {
      sessionStorage.setItem(key, legacy);
      localStorage.removeItem(key);
      migrated = true;
    }
  });
  return migrated;
}

export { AUTH_KEYS };
